module.exports = __webpack_public_path__ + "media/icons/offer-details-tyl@2x-6984b60c.png";